import {
  UpdateIconButton,
  formatDate,
  pn,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@compass/core";

import { ListBeProperty } from "components";
import { Permission, PermissionAction, ProviderListDto, ProviderListResource, SortObject } from "generated/openApi";
import { useNavigate } from "react-router-dom";
import { isAuthorized } from "services";
import { providerPageRoute } from "../ProviderPage/ProviderPage";

export const ProviderTable = (props: {
  rootPermission: Permission;
  tableContainerRef: React.RefObject<HTMLDivElement>;
  providers: ProviderListDto[];
  listTotal: number | undefined;
  resource: ProviderListResource;
  searchFocused: boolean;
  sortObjects: SortObject[] | undefined;
  sort: (sortObjects: SortObject[]) => void;
  selectId: (id: number) => void;
  selectedIds: number[];
  setSelectedIds: React.Dispatch<React.SetStateAction<number[]>>;
  getIdsPromise: () => Promise<any>;
  loadList: () => void;
}) => {
  const navigate = useNavigate();
  const properties = props.resource.properties || [];

  return (
    <TableContainer ref={props.tableContainerRef}>
      <Table stickyHeader>
        <TableHead>
          <TableRow>
            <TableCell style={{ width: "7%"}}>
                <ListBeProperty
                listProperty={properties.find((x) => x.propertyName === pn<ProviderListDto>("id"))}
                searchFocused={props.searchFocused}
                sortObjects={props.sortObjects}
                onChange={(sortObjects) => props.sort(sortObjects)}
             />
            </TableCell>
            <TableCell>
              <ListBeProperty
                listProperty={properties.find((x) => x.propertyName === pn<ProviderListDto>("fullName"))} 
                sortObjects={props.sortObjects}
                onChange={(sortObjects) => props.sort(sortObjects)}
                searchFocused={props.searchFocused}
              />
            </TableCell>
            <TableCell></TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {props.providers.map((providerItem) => (
            <TableRow
              key={providerItem.id}
              onClick={() => navigate(providerPageRoute.getPath({ id: providerItem.id, crudMode: "view", screenType: "dialog" }))}
            >
              <TableCell>
                {providerItem.id}
              </TableCell>
              <TableCell>
                {providerItem.fullName}
              </TableCell>
              <TableCell type="action">
                {isAuthorized(props.rootPermission, PermissionAction.Update) && (
                  <UpdateIconButton color="primary"
                    onClick={() => navigate(providerPageRoute.getPath({ id: providerItem.id, crudMode: "edit", screenType: "dialog" }))}
                  />
                )}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};
